import ReactDOM from "react-dom/client";
import "./index.css";
import LandingPage from "./views/LandingPage";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Priser from "./views/Priser";
import TeametBag from "./views/Team";
import Kontakt from "./views/Kontakt";
import NovoNordisk from "./views/Disclaimers/NovoNordisk";
import InnovationsFonden from "./views/Disclaimers/InnovationsFonden";
import ScrollToTop from "./helpers/ScrollToTop";
import SignUp from "./views/SignUp";
import Activation from "./views/Activation";
import Login from "./views/Login";
import ForgotPassword from "./views/ForgotPassword";
import PaymentConfirmation from "./views/PaymentConfirmation";
import Tutorials from "./views/Tutorials";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Router>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/tutorials" element={<Tutorials />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/priser" element={<Priser />} />
      <Route path="/team" element={<TeametBag />} />
      <Route path="/kontakt" element={<Kontakt />} />
      <Route path="/confirmation" element={<PaymentConfirmation />} />
      <Route path="/activation/:id" element={<Activation />} />
      <Route path="/disclaimers/novo-nordisk" element={<NovoNordisk />} />
      <Route
        path="/disclaimers/innovationsfonden"
        element={<InnovationsFonden />}
      />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
